module.exports = __webpack_public_path__ + "img/img (15).e9c59102.jpg";